import { defineComponent as E, computed as l, useId as R, createBlock as i, openBlock as d, unref as p, normalizeClass as s, withCtx as c, createElementVNode as r, createVNode as V, mergeProps as h, createCommentVNode as $, toDisplayString as n, resolveDynamicComponent as w, createTextVNode as x } from "vue";
import { RevButton as q } from "@ds/components/Button";
import { RevButtonCard as K } from "@ds/components/ButtonCard";
import { RevIllustration as P } from "@ds/components/Illustration";
import { isEmpty as U } from "../../utils/isEmpty.js";
import { tw as a } from "../../utils/tailwind.js";
const j = { class: "w-full" }, G = /* @__PURE__ */ E({
  name: "RevEditorialCard",
  __name: "EditorialCard",
  props: {
    alt: { default: "" },
    content: { default: "" },
    cta: { default: "" },
    image: {},
    imageProps: { default: () => ({ height: 164, width: 258 }) },
    titleKicker: { default: "" },
    title: {},
    titleTag: {},
    to: {},
    variant: { default: "default" }
  },
  setup(C) {
    const e = C, g = l(() => [{
      default: a`md:w-256`,
      full: a`md:w-full`
    }[e.variant]]), b = l(() => {
      const t = [
        a`shadow-short rounded-lg relative flex cursor-pointer overflow-hidden hover:shadow-long`,
        a`motion-safe:transition motion-safe:duration-300 motion-safe:ease-in`
      ], o = {
        default: a`h-[376px] flex-col`,
        full: a`h-[376px] flex-col md:h-[133px] md:flex-row`
      };
      return [t, o[e.variant]];
    }), y = l(() => {
      const t = "object-cover", o = {
        default: a`!h-[168px] w-full`,
        full: a`!h-[168px] w-full md:!h-auto md:w-[250px]`
      };
      return [t, o[e.variant]];
    }), N = l(() => {
      const t = a`bg-float-default-low flex flex-1 justify-between p-24 hover:bg-float-default-low-hover motion-safe:duration-300 motion-safe:ease-in`, o = {
        default: a`flex-col items-start`,
        full: a`grow flex-col items-start md:flex-row md:items-center`
      };
      return [t, o[e.variant]];
    }), k = l(() => [{
      default: a`line-clamp-2`,
      full: a`line-clamp-1`
    }[e.variant], a`text-static-default-hi body-1-bold`]), T = l(() => [{
      default: a`line-clamp-3`,
      full: a`line-clamp-2 md:line-clamp-3`
    }[e.variant]]), I = l(() => ({
      default: a`text-action-default-hi body-2-link mt-8 hover:text-action-default-hi-hover motion-safe:transition-colors`,
      full: a`md:ml-32 md:max-w-[212px]`
    })[e.variant]), u = l(() => {
      switch (e.variant) {
        case "full":
          return {
            props: {
              variant: "secondary"
            },
            tag: q
          };
        default:
          return { tag: "span" };
      }
    }), B = l(() => !U(e.cta)), m = R(), f = `title-${m}`, v = `title-kicker-${m}`;
    return (t, o) => (d(), i(p(K), {
      "aria-labelledby": `${v} ${f}`,
      class: s(g.value),
      to: t.to
    }, {
      default: c(() => [
        r("article", {
          class: s(b.value)
        }, [
          V(p(P), h(t.imageProps, {
            alt: t.alt,
            class: y.value,
            src: t.image
          }), null, 16, ["alt", "class", "src"]),
          r("div", {
            class: s(N.value)
          }, [
            r("div", j, [
              r("div", {
                id: v,
                class: "text-static-default-low caption"
              }, n(t.titleKicker), 1),
              (d(), i(w(t.titleTag), {
                id: f,
                class: s(k.value)
              }, {
                default: c(() => [
                  x(n(t.title), 1)
                ]),
                _: 1
              }, 8, ["class"])),
              r("p", {
                class: s(["text-static-default-mid body-2 mt-8", T.value])
              }, n(t.content), 3)
            ]),
            B.value ? (d(), i(w(u.value.tag), h({ key: 0 }, u.value.props, {
              class: I.value,
              tabindex: "-1"
            }), {
              default: c(() => [
                x(n(t.cta), 1)
              ]),
              _: 1
            }, 16, ["class"])) : $("", !0)
          ], 2)
        ], 2)
      ]),
      _: 1
    }, 8, ["aria-labelledby", "class", "to"]));
  }
});
export {
  G as default
};
